








































import {
  computed,
  defineComponent,
  getCurrentInstance,
  nextTick,
  onBeforeUnmount,
  reactive,
  ref,
  watch,
} from '@vue/composition-api';
import { CloseIcon } from 'tdesign-icons-vue';
import taskDetail from '@/renderer/views/desktop/FileManagement/Transmission/components/TaskDetail.vue';
import RowItem from '@/renderer/views/desktop/FileManagement/Transmission/components/RowItem.vue';
import { i18n_t } from '@/locales/i18n';

// 引入 compositions
import transmissionListHandle from '@/renderer/views/desktop/FileManagement/Transmission/transmissionListHandle';

// 引入工具类
import { FileInfo } from '@/renderer/scripts/utils/upload/types';
import { Task, TaskStatus } from '@/renderer/scripts/utils/TaskManager/types';
import store from '@/renderer/store';
import ipc from '@/renderer/scripts/utils/ipc';
import uploadTaskManager from '@/renderer/scripts/utils/upload/index';
import CustomDialog from '@/renderer/scripts/utils/CustomDialog';

export default defineComponent({
  components: {
    CloseIcon,
    taskDetail,
    RowItem,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const showTrans = ref(store.getters.haveUpload?.showTrans);
    const { upListTotal, handleTransmissionOperate } = transmissionListHandle();
    const arrowLeftPos = ref('24px');
    const transList = computed(() => upListTotal.value.filter(item => item.status !== TaskStatus.canceled));
    const finishedNum = computed(() => transList.value.filter(item => item.status === 'success').length);
    const allTransNum = computed(() => transList.value?.length);
    const allFinished = computed(() => transList.value.every(item => item.status === 'success'));
    const haveRunning = computed(() =>
      transList.value.some(item => {
        return item.status === 'running' || item.status === 'checking';
      }),
    );
    const runningData = computed(() => transList.value.filter((v: any) => v.status === 'running'));
    const allSpeed = computed(() =>
      runningData.value.reduce((prev: number, curr: any) => prev + Number(curr.speed), 0),
    );
    const webTransShow = ({ show }: { show?: boolean }) => {
      showTrans.value = show !== undefined ? show : true;
    };
    ipc.on(ipc.RENDERER_EVENTS_MAP.WEB_TRANS_SHOW, webTransShow);
    const transShowChange = () => {
      showTrans.value = !showTrans.value;
    };
    ipc.on(ipc.RENDERER_EVENTS_MAP.TRANS_SHOW_CHANGE, transShowChange);
    const taskDetail = reactive({
      task: {},
      show: false,
    });
    const methods = {
      closeTrans() {
        if (!allFinished.value) {
          const deleteDialog = CustomDialog.confirm({
            header: i18n_t('确定关闭吗'),
            body: i18n_t('尚有任务在上传，关闭后将取消正在上传的任务，并清空列表'),
            theme: 'warning',
            onConfirm: () => {
              if (deleteDialog.hide) {
                deleteDialog.hide();
              }
              uploadTaskManager.cancel('all');
              showTrans.value = false;
            },
            onCancel: () => {
              if (deleteDialog.hide) {
                deleteDialog.hide();
              }
            },
          });
        } else {
          // uploadTaskManager.cancel('all');
          showTrans.value = false;
        }
      },
      onAction(event: { command: string; task: Task<FileInfo> }) {
        const { command, task } = event;
        if (command === 'openTask') {
          if (!task.isDir) return;
          taskDetail.show = true;
          task.sortListByStatus();
          taskDetail.task = task;
        } else {
          handleTransmissionOperate(command, task, 'upload');
        }
      },
      percentFunc(item: Task<FileInfo>) {
        if (item.getListLength() === 1) {
          return `${item.getItem(0).percent * 100}%`;
        }
        const tmp = item.progressText.split('/');
        return `${(Number(tmp[0]) / Number(tmp[1])) * 100}%`;
      },
    };
    onBeforeUnmount(() => {
      ipc.off(ipc.RENDERER_EVENTS_MAP.WEB_TRANS_SHOW, webTransShow);
      ipc.off(ipc.RENDERER_EVENTS_MAP.TRANS_SHOW_CHANGE, transShowChange);
    });
    watch(showTrans, () => {
      if (showTrans.value) {
        nextTick(() => {
          const transButton = document.getElementById('transButton');
          const transCenter = document.getElementById('trans');
          const transButtonLeft = transButton?.offsetLeft as number;
          const transCenterLeft = transCenter?.offsetLeft as number;
          const transCenterWidth = transCenter?.offsetWidth as number;
          let arrowleft = transButtonLeft - transCenterLeft + 256;
          // 箭头超过消息中心宽度,需要保证在宽度范围之内
          if (arrowleft > transCenterWidth - 25) {
            arrowleft = transCenterWidth - 25;
          }
          arrowLeftPos.value = `${arrowleft}px`;
        });
      }
    });
    return {
      transList,
      upListTotal,
      showTrans,
      finishedNum,
      allTransNum,
      allFinished,
      haveRunning,
      allSpeed,
      taskDetail,
      arrowLeftPos,
      ...methods,
    };
  },
});
